import type { Phrases } from '../Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	COMMON_FIELD_NAME,
	COMMON_FREETEXT_FIELD_NAME,
	SUBSTANCE,
} from '../constants';


export const SubstanceDetailsTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
		setScrollRef,
		setValue,
	} =	useFormContext();
	const scrollRef = useRef();
	const inputRef = useRef<HTMLInputElement | null>(null);
	const substance = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE}) as string;
	const isOther = substance === SUBSTANCE.OTHER;
	const isMixture = substance === SUBSTANCE.MIXTURE;
	const isNeither = !isOther && !isMixture && !!substance;

	useEffect(() => {
		setValue(COMMON_FREETEXT_FIELD_NAME.SUBSTANCE_DETAILS, '', { shouldValidate: true });
		inputRef.current?.focus();
	}, [inputRef, inputRef?.current, substance]);

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.SUBSTANCE_DETAILS, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	const substanceDetailsLabel = phrases['notificationForm.common.substanceDetailsField.label'];
	return (
		<TextField
			errorSummaryLabel={substanceDetailsLabel}
			fullWidth
			label={
				<Span
					className='text-lg'
					elementRef={scrollRef}
				>
					{
						substanceDetailsLabel
					}
				</Span>
			}
			name={COMMON_FIELD_NAME.SUBSTANCE_DETAILS}
			ref={inputRef}
			showIf={() => isNeither}
		/>
	);
};

